'use client';

import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import Link from 'next/link';

import Links from './Links';

interface HeaderLinksProps {
  isInternal: boolean;
  isLoggedIn: boolean;
  isMobile: boolean;
}

const HeaderLinks = ({ isInternal, isLoggedIn, isMobile }: HeaderLinksProps) =>
  isInternal ? (
    <>
      {isLoggedIn && (
        <Link prefetch={false} href="/roadmap" style={{ marginRight: isMobile ? '2rem' : '3rem' }}>
          <Typography
            component="span"
            sx={{
              fontWeight: 600,
              letterSpacing: '0.08em',
              color: '#fff',
              display: 'block',
              fontSize: '14px',
              textTransform: 'uppercase',
              position: 'relative',
              padding: '0px 1px',
              alignItems: 'center',
            }}
          >
            ROADMAPS
          </Typography>
        </Link>
      )}
      <Links isLoggedIn={isLoggedIn} isMobile={isMobile} />
    </>
  ) : null;

export default HeaderLinks;
